import { Component } from "@ecs/Component";

export function setElementVisibility(element: HTMLElement, visible: boolean) {
    element.style.display = visible ? 'block' : 'none'
}
export class OverlayInterface extends Component {
    element!: HTMLDivElement
    setup(_data: any) {
        super.setup(_data)
        const overlayContainer = document.querySelector('div.overlay-interface') as HTMLDivElement
        // create child element
        this.element = document.createElement('div')
        overlayContainer.appendChild(this.element)
        if (_data.innerHTML !== undefined) this.element.innerHTML = _data.innerHTML
    }
    onDestroy(): void {
        this.element.remove()
    }
    onActiveStateChanged(): void {
        setElementVisibility(this.element, this.enabled)
    }
}